import { OutletContext } from '@typings';
import { usePlatformAppsTemplates } from '@hooks/platformApps';

import { SchemaParamsSection } from '@components/Schema';

type Props = {
  type: 'input' | 'output';
  templateVersion: string;
  templateName: string;
  params:
    | OutletContext.PlatformAppsInstance['input']
    | OutletContext.PlatformAppsInstance['output'];
  onDownload?: () => void;
};
export const PlatformAppManagementParamsSection: React.FC<Props> = ({
  type,
  templateVersion,
  templateName,
  params,
  onDownload,
}) => {
  const { isFetched, template } = usePlatformAppsTemplates({
    version: templateVersion,
    appName: templateName,
  });

  return (
    <SchemaParamsSection
      title={type}
      params={params}
      isLoading={!isFetched}
      schema={template?.[type]}
      onDownload={onDownload}
    />
  );
};
